define('Facets.MultiAddToCart.Options.View', [
    'facets_multi_add_to_cart_itemoptions.tpl',

    'Backbone'
], function (
    facets_multi_add_to_cart_itemoptions_tpl,

    Backbone
) {
    'use strict';

    return Backbone.View.extend({
        template: facets_multi_add_to_cart_itemoptions_tpl,

        contextDataRequest: ['item'],

        initialize: function initialize(options) {
            var _this = this;

            _this.environment = options.container.getComponent('Environment')
            _this.getRegistrationType = options.getRegistrationType;
            // console.log('_this', _this);
        },

        render: _(Backbone.View.prototype.render).wrap(function render(fn) {
            var _this = this;
            var args = arguments;
            var userProfile = _this.options.container.getComponent('UserProfile');

            userProfile.getUserProfile().done(function (profile) {
                _this.userProfile = profile;
            }).always(function () {
                fn.apply(_this, _(args).toArray().slice(1));
            });
        }),

        disableOption: function () {
            //We've got to disable loginToSeePrices feature if customer registration is disabled.
            var _this = this;
            var configuration = _this.options.container.getComponent('Environment');
            return _this.getRegistrationType !== 'disabled' && configuration.getSiteSetting('requireloginforpricing') === 'T' && _this.userProfile.isloggedin !== true;
        },

        getContext: function getContext() {
            var _this = this;

            _this.item = _this.contextData.item && _this.contextData.item();
            // console.log('_this.item', _this.item);
            var itemOptions = _this.item.itemoptions_detail.fields;
            var grindsArr = _.findWhere(itemOptions, {internalid: 'custcol_web_grinds'});
            var grindsValue;
            var opID = 'option1';
            if(grindsArr && grindsArr.values){
                grindsValue = _.reject(grindsArr.values, function(arrItem){ 
                    return arrItem.label === "";
                });

                opID = grindsArr.internalid;
            }

            // console.log('grindsArr', grindsArr);
            // console.log('grindsValue', grindsValue);

            return {
                isOptionEnabled: !_this.disableOption(),
                grinds: grindsValue || {},
                hasGrinds: !!grindsValue || false,
                optionName:  opID
            };
        }
    });
});
